export default __webpack_public_path__ + "static/media/ic_bsc_40.bef7be81.svg";